import { defineStore } from "pinia";

export const useEditorStore = defineStore("editor", {
	state: () => ({
		mode: "edit" as "config" | "edit" | "preview",
	}),
});
